import type { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { ButtonProps } from '@app/components/ui/button'
import { Button } from '@app/components/ui/button'
import { Tooltip } from '@app/components/ui/tooltip'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'

interface Props extends ButtonProps {
  text?: string | React.ReactNode
}

const CreateEntityButton: FC<Props> = ({ text = 'Create event', ...rest }) => {
  const { user } = useStoreCurrentUser()
  const location = useLocation()
  const navigate = useNavigate()

  if (!user) {
    return null
  }

  const handleClick = () => {
    navigate('new', { state: { sender: location.pathname } })
  }

  return (
    <Tooltip content="Create event">
      <Button onClick={handleClick} {...rest}>
        {text}
      </Button>
    </Tooltip>
  )
}

export default CreateEntityButton
